<p class="account-delete-profile-paragraph ods-typography-body-s-regular">{{ 'delete_profile_text' | translate }}</p>
<button box-button theme="primary" class="account-delete-profile" (click)="initiateDeletionFlow()">
  {{ 'delete_profile' | translate }}
</button>
